<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="purchaseItems"
    :indexNested="true"    
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="hasTableTitle"
    :tableTitle="tableTitle"
    @row-clicked="handleRowClicked"
    :addAndEdit="addAndEdit"
  >   
      

    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"        
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"        
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>    


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="6"><strong class="title">Total dos Itens</strong></td>
        <td colspan="2" class="text-xs-right title"><strong>{{ this.purchaseTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total dos Itens</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.purchaseTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        { field: 'unitPrice', mask: 'currency_10d' }, 
        { field: 'quantity', mask: 'number'},
        { field: 'price',mask: 'currency'},
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    purchaseItems: {
      type: Array,
      default: () => [],
    },
    purchaseTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Item de Compra"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Compra"
    },
    addAndEdit: {
      type: Boolean,
      default: true,
    },
  },
  created() {
  },
  computed: {
    tableHeaders() {  
      return [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Estoque", align: "left", sortable: true, value: "storage.name" },
        { text: "R$", align: "left", sortable: true, value: "unitPrice" },
        { text: "Qtd. Emb.", align: "left", sortable: true, value: "packagingQuantity" },
        { text: "Qtd.", align: "left", sortable: true, value: "quantity" },
        { text: "Und.", align: "left", sortable: true, value: "packaging.unitName" },
        { text: "R$ Total", align: "left", sortable: true, value: "price" },        
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ]
    }
  },
  methods: {
    entryUpdated: function(editedPurchaseItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      this.recalculatePurchaseTotalPrice();
    },
    entryCreated: function(newPurchaseItem){
      console.log("newPurchaseItem", newPurchaseItem);
      this.purchaseItems.push(newPurchaseItem);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      this.recalculatePurchaseTotalPrice();
    },
    entryDeleted: function(deletedPurchaseItem){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      this.recalculatePurchaseTotalPrice();
    },
    recalculatePurchaseTotalPrice: function() {
      var newPurchaseTotalPrice = 0;
      for (var purchase in this.purchaseItems) {
        if(!this.purchaseItems[purchase]._destroy) {
          newPurchaseTotalPrice += this.purchaseItems[purchase].price;
        }
      }
      newPurchaseTotalPrice = _.round(newPurchaseTotalPrice, 2);
      this.$emit('update:purchaseTotalPrice', newPurchaseTotalPrice);
    },
    handleRowClicked: function(rowArguments) {
      // console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
  }
};
</script>

<style scoped></style>
